import AccountMenuMobileView from './views/account_menu_mobile';

const createComponent = ({el}) => {
    const view = new AccountMenuMobileView({el}); // eslint-disable-line no-unused-vars
    window.AccountMenuMobileView = view;
};

export default createComponent;
